import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  template: `
  <div class="form-group">
    <label *ngIf="!!label" class="form-label">{{ label }}</label>
    <div class="box" *ngIf="type==='switch'">
      <label class="m-r-sm" [ngClass]="{ 'disabled': !!yes }" (click)="toggle()">{{ noLabel }}</label>
      <input-switch class="middle m-r-sm"
        [(value)]="yes"
      ></input-switch>
      <label [ngClass]="{ 'disabled': !yes }" (click)="toggle()">{{ yesLabel }}</label>
    </div>
    <div class="box" *ngIf="type==='checkbox'" [ngClass]="{ 'disabled': !yes }">
      <input-checkbox class="middle"
        [label]="yesLabel"
        [(value)]="yes"
      ></input-checkbox>
    </div>
  </div>
`,
  styles: [
    `
    .form-group {
      margin-bottom: 0;
    }
    .box {
      display: flex;
      flex-direction: row;
      align-content: center;
    }
    .box label {
      cursor: pointer;
    }
    .middle {
      margin-top: 3px;
    }
    .disabled {
      opacity: .4;
    }

    /* The container */
    .container {
      display: block;
      position: relative;
      padding-left: 20px;
      margin-bottom: 12px;
      cursor: pointer;
      //font-size: 22px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    /* Hide the browser's default checkbox */
    .container input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 12px;
      width: 12px;
      background-color: var(--primary); //#eee;
      margin-top: 3px;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
      background-color: var(--primary); //#ccc;
    }

    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
      background-color: var(--primary); //#2196F3;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
      content: "";
      position: absolute;
      display: none;
    }

    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
      display: block;
    }

    /* Style the checkmark/indicator */
    .container .checkmark:after {
      left: 4px;//9px;
      top: 2px;//5px;
      width: 5px;
      height: 7px;
      border: solid darkgreen;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
    `
  ],
  selector: 'input-yes-no'
})
export class InputYesNoComponent implements OnInit, OnDestroy {


  @Input() public type: 'switch' | 'checkbox' = 'switch';
  @Input() public label: string;

  @Input() public yesValue: any = 'yes';
  @Input() public yesLabel: string = 'Yes';
  @Input() public noValue: any = 'no';
  @Input() public noLabel: string = 'No';

  @Output() public valueChange = new EventEmitter<string>();
  private _value: string;
  @Input('value')
  public get value(): string {
    return this._value;
  }
  public set value(v: string) {
    const next = v || this.noValue; // default 'no'
    if (this._value !== next) {
      this._value = next;
      this.valueChange.emit(this._value);
    }
  }

  public get yes(): boolean {
    return this._value === this.yesValue; 
  }
  public set yes(y: boolean) {
    this.value = y ? this.yesValue : this.noValue; 
  }

  public id: string;

  constructor() {}

  ngOnInit() {
    this.id = '_id_' + Math.floor(Math.random() * 999 + 100);
  }

  ngOnDestroy(): void {}

  toggle() {
    this.yes = !this.yes;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/common-livee/input-yes-no.component.ts